<template>
  <div class="sidebar-container" :class="{ 'sidebar-hidden': isCollapsed }">
    <!-- 侧边栏内容 -->
    <div class="sidebar">
      <!-- 顶部功能区：语言切换 -->
      <div class="top-controls">
        <div class="lang-switch" @click="toggleLanguage">
          {{ $t('sidebar.language') }}
        </div>
      </div>

      <!-- 顶部标题和搜索区域 -->
      <div class="sidebar-header">
        <div class="logo">{{ $t('sidebar.title') }}</div>
        <div class="header-icons">
          <!-- 右上角的折叠按钮 -->
          <img class="collapse-icon" @click="toggleSidebar" src="@/assets/icons/closeSidebar.png">
        </div>
      </div>

      <!-- 病害分析链接 -->
      <div class="disease-analysis-container">
        <router-link to="/disease-analysis" class="disease-analysis-link">
          <img class="analysis-icon" src="@/assets/icons/analysis.png">
          <span>{{ $t('sidebar.analysis') }}</span>
        </router-link>
      </div>

      <!-- 新建对话按钮 -->
      <div class="new-chat-container">
        <button class="new-chat-button" @click="newChat">
          <img class="new-chat-icon" src="@/assets/icons/newChat.png">
          <span>{{ $t('sidebar.newChat') }}</span>
        </button>      </div>
      
      <!-- 底部区域 -->
      <div class="sidebar-footer">
        <div class="logout-container">
          <button class="logout-button" @click="handleLogout">
            <img class="logout-icon" src="@/assets/icons/logout.png">
            <span>{{ $t('sidebar.logout') }}</span>
          </button>
        </div>
      </div>
      <!-- <div class="sidebar-footer">
        <div class="user-info">
          <div class="avatar">L</div>
          <div class="username">Lychee</div>
        </div>
      </div> -->
    </div>

    <!-- 当侧边栏隐藏时，显示在左上角的展开按钮 -->
    <div v-if="isCollapsed" class="expand-button" @click="toggleSidebar">
      <img class="expand-icon" src="@/assets/icons/openSidebar.png">
    </div>
  </div>
</template>

<script>
import { logout } from '@/utils/auth.js';

export default {
  name: 'AppSidebar',
  data() {
    return {
      isCollapsed: false
    }
  },
  methods: {
    toggleLanguage() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLang;
      localStorage.setItem('user_language', newLang);
    },
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
      // 通知父组件侧边栏状态已变化
      this.$emit('sidebar-toggle', this.isCollapsed);
    },
    newChat() {
      // 触发新建对话事件
      this.$emit('new-chat');
    },
    handleLogout() {
      // 确认登出
      if (confirm(this.$t('sidebar.confirmLogout'))) {
        logout();
        this.$router.push('/login');
      }
    }
  }
}
</script>

<style scoped>
.sidebar-container {
  position: relative;
  height: 100vh;
  transition: all 0.3s ease;
}

.sidebar-hidden .sidebar {
  width: 0;
  overflow: hidden;
}

.sidebar {
  width: 100%;
  height: 100vh;
  background-color: #F3F3F3;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  transition: width 0.3s ease;
}

.top-controls {
  padding: 20px 45px 0;
  display: flex;
  justify-content: flex-start;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  margin-top: 15px; /* Reduced margin since lang switch is above */
  margin-left: 45px;
  width: auto; /* Remove fixed width */
  height: auto;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #303030;
  line-height: 33px;
  text-align: left;
  font-style: normal;
}

.header-icons {
  display: flex;
  align-items: center;
  margin-right: 54px;
  margin-top: 15px; /* Align with logo */
}

.search-icon,
.menu-icon,
.collapse-icon {
  color: #666;
  cursor: pointer;
}

.collapse-icon {
  font-size: 14px;
}

.user-info-section {
  padding: 10px 45px;
  margin-bottom: 20px;
}

.user-welcome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.welcome-text {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #303030;
}

.expand-button {
  position: absolute;
  top: 44px;
  left: 20px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
}

.expand-icon {
  color: #666;
}

.new-chat-container {
width: 228px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  text-align: center;
  margin: 10px auto;
}

.new-chat-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
}

.new-chat-button span {
  width: auto; /* Allow text to expand */
  flex: 1; /* Take remaining space */
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px; /* Slightly smaller for better fit */
  color: #303030;
  line-height: 22px;
  text-align: left; /* Align left */
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.disease-analysis-container {
  width: 228px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  text-align: center;
  margin: 10px auto;
}

.disease-analysis-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.disease-analysis-link:hover {
  background-color: #e9e9e9;
}

.disease-analysis-link span {
  width: auto; /* Allow text to expand */
  flex: 1;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #303030;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.analysis-icon {
  width: 16px;
  height: 16px;
}

.sidebar-footer {
  margin-top: auto;
  padding: 20px 0;
}

.logout-container {
  width: 228px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  text-align: center;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
}

.logout-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-button:hover {
  background-color: #f5f5f5;
}

.logout-button span {
  width: auto;
  flex: 1;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #666;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.logout-icon {
  width: 16px;
  height: 16px;
}

.square-button {
  width: 38px;
  height: 38px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
}

.section-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.section-item:hover {
  background-color: #e9e9e9;
}

.section-item.active {
  background-color: #e1e1e1;
}

.with-arrow {
  justify-content: space-between;
}

.arrow-icon {
  color: #999;
}

.sidebar-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  color: #999;
  font-size: 14px;
}

.add-icon {
  cursor: pointer;
  color: #666;
}

.date-label {
  padding: 8px 16px;
  color: #999;
  font-size: 14px;
}

.notification-dot {
  width: 8px;
  height: 8px;
  background-color: #f44336;
  border-radius: 50%;
  position: absolute;
  right: 16px;
}

.sidebar-footer {
  margin-top: auto;
  border-top: 1px solid #e0e0e0;
}

.download-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 12px 16px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.username {
  flex: 1;
}

.status-icon {
  color: #999;
}

.lang-switch {
  cursor: pointer;
  font-size: 12px;
  color: #666;
  padding: 4px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 15px; /* More rounded */
  background: white;
  display: inline-block;
}
</style>